import {
  getAccessToken,
  getSubId,
  getAccountId,
  storeProfileInfo,
  getAsyncProfileInfo,
  getBrandId,
  getOperatorId,
} from '../database/DataBase';
let USE_OFFLINE = false;
const BASE_URL = 'https://partners.ulka.tv/api/index.php/v1/';
// const BASE_URL = 'http://202.62.66.122/api/index.php/v1/';
export const PAYMENT_URL =
  'https://partners.ulka.tv/portal/index.php?r=portal/online-pay/checkout';
// export const PAYMENT_URL =
//   'http://202.62.66.114/portal/index.php?r=portal/online-pay/checkout';
const LOGIN_URL = BASE_URL + 'user/login';
const OTP_URL = BASE_URL + 'webcustomer/send-otp';
const SIGNUP_URL = BASE_URL + 'webcustomer/signup';
const FORGETPASS_URL = BASE_URL + 'webcustomer/forget-password';
const PROFILE_URL = BASE_URL + 'subscriber/profile';
const UPDATE_PROFILE_URL = BASE_URL + 'subscriber/';
const ACCOUNT_BOUQUES_URL =
  BASE_URL +
  'account-bouque?expand=boxtype_lbl,type_lbl,status_lbl,refundAble,,amount_charged&sort=created_at&filter[account_id]=';
const CHANNEL_LIST_URL =
  BASE_URL +
  'bouque/[bouque_id]?fields=id,name&expand=channels';
const LIST_COMPLAINTS_URL =
  BASE_URL +
  'complaint?expand=priority_lbl,created_by_lbl,operator_lbl,location_lbl,sublocation_lbl,category_lbl,subcategory_lbl,smartcard_lbl,stb_lbl,status_lbl,reply_lbl,name_lbl&page=1&per-page=50';
const MAIN_CATEGORY_COMPLAINT_URL =
  BASE_URL + 'complaint-category/list?filter[status]=1&fields=name,id';
const SUB_CATEGORY_COMPLAINT_URL =
  BASE_URL + 'complaint-subcategory/list?filter[status]=1&filter[category_id]=';
//const FILE_COMPLAINT = 'http://202.62.66.102/api/index.php/v1/complaint';
const FILE_COMPLAINT = BASE_URL + 'complaint';
// const REPLY_TO_COMPLAINT =
//   'http://202.62.66.102/api/index.php/v1/complaint-reply';
const REPLY_TO_COMPLAINT = BASE_URL + 'complaint-reply';
const LIST_AVAILABLE_ALACARTES =
  BASE_URL +
  'bouque/list?fields=id,name,description,rate&expand=type_lbl,boxtype_lbl,mrp&filter[type]=3&notfilter[account_id]=';
const LIST_APPLICABLE_ADDONS =
  BASE_URL +
  'bouque/list?fields=id,name,description,mrp&expand=type_lbl,boxtype_lbl,name_lbl,alacarte,package&filter[type]=2&notfilter[account_id]=';
const LIST_APPLICABLE_BASEPACKS =
  BASE_URL +
  'bouque/list?fields=id,name,description,rate,mrp,tax&expand=type_lbl,boxtype_lbl&filter[type]=1&filter[account_id]=';
const SELECTED_PACK_PRICES = BASE_URL + 'recharge-period/';
const LIST_BOUQUETS = BASE_URL + "bouque/list?sort=sort_by,name&fields=id,name,code,description,mrp,drp,tax,type&expand=rate,type_lbl,boxtype_lbl,is_exclusive_lbl,is_promotional_lbl&filter[except_base]=0&filter[account_id]=";
const OPERATOR_DETAILS_URL = BASE_URL+"operator";
const LIST_TRANSACTION_URL = BASE_URL+"subscriber-wallet?filter[account_id]=<account_id>&expand=name_lbl,operator_id_lbl,discount_lbl,created_by_lbl,notes_lbl,transactionfor_lbl&page=1&per-page=50";
const LIST_RECEIPTS_URL = BASE_URL+"act-dec-log?filter[account_id]=<account_id>&page=1&per-page=50";
const LAST_TRANSACTION_URL = BASE_URL+"subscriber-transaction?filter[account_id]=<account_id>&expand=name_lbl,operator_id_lbl,discount_lbl,created_by_lbl,notes_lbl,transactionfor_lbl&page=1&per-page=1";

export const login = (accountNumber, password) => {
  const bodyvar = {
    LoginForm: {
      username: accountNumber,
      password: password,
    },
  };

  return fetch(LOGIN_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      authkey: 'xqibzknznwb29de15s44',
    },
    body: JSON.stringify(bodyvar),
  }).then((serverdata) => {
    return serverdata.json();
  });
};

export const recharge = async (accountId) => {
  const token = await getAccessToken();

  const bodyvar = {
    account_ids: accountId,
    bouque_ids: 1,
    rperiod_id: 1,
    type: 'addon',
    remark: 'Remark for renewals',
  };

  return fetch(PAYMENT_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
    body: JSON.stringify(bodyvar),
  }).then((serverdata) => {
    return serverdata.json();
  });
};

export const getOTP = (accountNumber, username) => {
  const bodyvar = {
    customer_detail: accountNumber,
    account_detail: username,
  };

  return fetch(OTP_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(bodyvar),
  }).then((serverdata) => {
    return serverdata.json();
  });
};

export const SignUp = (accountNumber, username, password, otp) => {
  const bodyvar = {
    customer_detail: accountNumber,
    account_detail: username,
    password: password,
    otp: otp,
  };

  return fetch(SIGNUP_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(bodyvar),
  }).then((serverdata) => {
    return serverdata.json();
  });
};

export const ForgetPass = (accountNumber, username, password, otp) => {
  const bodyvar = {
    customer_detail: accountNumber,
    account_detail: username,
    password: password,
    otp: otp,
  };

  return fetch(FORGETPASS_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(bodyvar),
  }).then((serverdata) => {
    return serverdata.json();
  });
};

export const getProfileInfo = async (off) => {
  return getProfileInfoFromNetwork();
};

export const getProfileInfoFromNetwork = async () => {
  const token = await getAccessToken();
  const subId = await getSubId();

  return fetch(PROFILE_URL + '/' + subId, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
  })
    .then((serverdata) => {
      return serverdata.json();
    })
    .then((jsondata) => {
      return jsondata;
    });
};

export const updateProfileInfo = async (
  fname,
  mname,
  lname,
  email,
  dob,
  pincode,
  address,
) => {
  const subId = await getSubId();
  const token = await getAccessToken();
  const bodyvar = {
    fname: fname,
    mname: mname,
    lname: lname,
    email: email,
    dob: dob,
    pincode: pincode,
    address: address,
  };

  return fetch(UPDATE_PROFILE_URL + subId, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
    body: JSON.stringify(bodyvar),
  }).then((serverdata) => {
    return serverdata.json();
  });
};

export const getBouquesForAccount = async () => {
  const accId = await getAccountId();
  const token = await getAccessToken();

  return fetch(ACCOUNT_BOUQUES_URL + accId, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
  }).then((serverdata) => {
    return serverdata.json();
  });
};

export const getGenreWiseChannelsByBouquet = async (bouque_id) => {
  const token = await getAccessToken();

  return fetch(CHANNEL_LIST_URL.replace('[bouque_id]', bouque_id), {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
  }).then((serverdata) => {
    return serverdata.json();
  });
};

export const listAllComplaints = async () => {
  const token = await getAccessToken();

  return fetch(LIST_COMPLAINTS_URL, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
  }).then((serverdata) => {
    return serverdata.json();
  });
};

export const listAllComplaintsMainCategories = async () => {
  const token = await getAccessToken();
  return fetch(MAIN_CATEGORY_COMPLAINT_URL, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
  }).then((serverdata) => {
    return serverdata.json();
  });
};

export const listAllComplaintsSubCategories = async (no) => {
  const token = await getAccessToken();
  return fetch(SUB_CATEGORY_COMPLAINT_URL + no + '&fields=id,name', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
  }).then((serverdata) => {
    return serverdata.json();
  });
};

export const fileComplaint = async (catid, subcatid, complaint) => {
  const accId = await getAccountId();
  const token = await getAccessToken();
  const bodyvar = {
    category_id: catid,
    subcategory_id: subcatid,
    opening_remark: complaint,
    account_id: accId,
  };

  return fetch(FILE_COMPLAINT, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
    body: JSON.stringify(bodyvar),
  }).then((serverdata) => {
    return serverdata.json();
  });
};

export const sendReplyToComplaint = async (id, message) => {
  const token = await getAccessToken();
  const bodyvar = {
    complaint_id: id,
    description: message,
    user_replied: 1,
  };

  return fetch(REPLY_TO_COMPLAINT, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
    body: JSON.stringify(bodyvar),
  }).then((serverdata) => {
    return serverdata.json();
  });
};

export const listAvailableAlacartes = async () => {
  const token = await getAccessToken();
  const accId = await getAccountId();
  
  return fetch(LIST_AVAILABLE_ALACARTES + accId, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
  }).then((serverdata) => {
    return serverdata.json();
  });
};

export const listApplicableAddons = async () => {
  const token = await getAccessToken();
  const accId = await getAccountId();
  const profData = await getAsyncProfileInfo();
  const brandId = await getBrandId();

  return fetch(
    LIST_APPLICABLE_ADDONS +
      accId +
      '&filter[is_online_app]=1&filter[brand_id]=' +
      brandId,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token,
      },
    },
  ).then((serverdata) => {
    return serverdata.json();
  });
};

export const listApplicableBasePacks = async () => {
  const token = await getAccessToken();
  const accId = await getAccountId();
  // const profData = await getAsyncProfileInfo();
  const brandId = await getBrandId();
  const opId = await getOperatorId();
  // console.log('acc id', accId);
  // console.log('brand', brandId);
  return fetch(
    LIST_BOUQUETS + accId,
    // +
    // '&filter[operator_id]=' +
    // opId +
    // '&filter[brand_id]=' +
    // brandId,

    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token,
      },
    },
  ).then((serverdata) => {
    return serverdata.json();
  });
};

export const getPricesofSelectedBouques = async (id) => {
  const token = await getAccessToken();
  const accId = await getAccountId();
  const bodyvar = {
    account_id: accId,
  };
  return fetch(SELECTED_PACK_PRICES + id + '/mview',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token,
      },
      body: JSON.stringify(bodyvar),
    },
  ).then((serverdata) => {
    return serverdata.json();
  });
};

export const giveFeedback = async (rating, reply) => {
  const token = await getAccessToken();

  const bodyvar = {
    rating,
    reply,
    devicetype: 'android',
  };
  return fetch(BASE_URL + 'feedback', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
    body: JSON.stringify(bodyvar),
  }).then((serverdata) => {
    // // console.log(serverdata);
    return serverdata.json();
  });
};

export const getLcoContactDetails = async () => {
  const token = await getAccessToken();
  const operatorId = await getOperatorId();

  return fetch(OPERATOR_DETAILS_URL + '/' + operatorId, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
  })
  .then((serverdata) => {
    console.log(serverdata);
    return serverdata.json();
  })
  .then((jsondata) => {
    return jsondata;
  });
};

export const getTransactionList = async () => {
  const token = await getAccessToken();
  const accId = await getAccountId();

  return fetch(LIST_TRANSACTION_URL.replace('<account_id>', accId), {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
  })
  .then((serverdata) => {
    console.log(serverdata);
    return serverdata.json();
  })
  .then((jsondata) => {
    return jsondata;
  });
};

export const getReceiptList = async () => {
  const token = await getAccessToken();
  const accId = await getAccountId();

  return fetch(LIST_RECEIPTS_URL.replace('<account_id>', accId), {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
  })
  .then((serverdata) => {
    console.log(serverdata);
    return serverdata.json();
  })
  .then((jsondata) => {
    return jsondata;
  });
};

export const getLastTransaction = async () => {
  const token = await getAccessToken();
  const accId = await getAccountId();

  return fetch(LAST_TRANSACTION_URL.replace('<account_id>', accId), {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
  })
  .then((serverdata) => {
    console.log(serverdata);
    return serverdata.json();
  })
  .then((jsondata) => {
    return jsondata;
  });
};
